<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem [disabled]="editButtonIsDisabled" (click)="onEditTriggerQuery()">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit trigger action</span>
    </button>
    <button ngbDropdownItem
            [ngClass]="{'text-danger': deleteButtonIsEnabled}"
            [disabled]="!deleteButtonIsEnabled"
            (click)="onDeleteTriggerQuery()">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete trigger action</span></button>
  </div>
</div>
